import { render } from "./PvpCarsPage.vue?vue&type=template&id=1d15f396&scoped=true"
import script from "./PvpCarsPage.vue?vue&type=script&lang=ts"
export * from "./PvpCarsPage.vue?vue&type=script&lang=ts"

import "./PvpCarsPage.vue?vue&type=style&index=0&id=1d15f396&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d15f396"

export default script